import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import yellowIcon from '../../assets/img/yellow_icon.png';

interface ViewInShopActionProps {
  item: {
    d2rshopproductlink?: string;
  };
  size?: 'small' | 'medium' | 'large';
  sx?: any;
}

export default function ViewInShopAction({ item, size = 'small', sx = {} }: ViewInShopActionProps) {
  const { t } = useTranslation();

  const handleViewInShop = () => {
    if (item.d2rshopproductlink) {
      window.open(item.d2rshopproductlink, '_blank');
    }
  };

  // Don't render if no shop link
  if (!item.d2rshopproductlink) {
    return null;
  }

  return (
    <Tooltip title={t('search.vendor.viewInShop', 'View in Shop')}>
      <IconButton
        onClick={handleViewInShop}
        size={size}
        sx={{
          color: (theme) => theme.palette.text.secondary,
          border: (theme) => `1px solid ${theme.palette.secondary.main}33`,
          '&:hover': {
            color: (theme) => theme.palette.text.primary,
            border: (theme) => `1px solid ${theme.palette.secondary.main}`,
          },
          ...sx,
        }}
      >
        <img src={yellowIcon} alt="shop" style={{ width: '20px', height: '20px' }} />
      </IconButton>
    </Tooltip>
  );
}
